export function OutlineTimelineIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.0016 7.0032C6.10705 7.0032 7.0032 6.10705 7.0032 5.0016C7.0032 3.89615 6.10705 3 5.0016 3C3.89615 3 3 3.89615 3 5.0016C3 6.10705 3.89615 7.0032 5.0016 7.0032Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 8.0016C21 9.1056 20.1024 10.0032 18.9984 10.0032C18.768 10.0032 18.5424 9.9648 18.336 9.888C17.5584 9.6144 16.9968 8.8752 16.9968 8.0016C16.9968 7.128 17.5536 6.3936 18.3264 6.12C18.5376 6.0432 18.7632 6 18.9984 6C20.1024 6 21 6.8976 21 8.0016Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18C15 19.6569 16.3431 21 18 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.9984 14.4968C6.9984 15.404 6.3936 16.172 5.5632 16.4168C5.3856 16.4696 5.1936 16.4984 4.9968 16.4984C3.8928 16.4984 3 15.6008 3 14.4968C3 13.3928 3.8928 12.5 4.9968 12.5C5.1984 12.5 5.3904 12.5288 5.5728 12.5864C6.3984 12.8312 6.9984 13.5944 6.9984 14.4968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.57275 12.5863C5.70715 12.3847 5.86075 12.1975 6.02875 12.0295C6.66235 11.3959 7.54075 11.0023 8.51035 11.0023H16.008C16.9488 11.0023 17.784 10.5703 18.336 9.88867"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99854 5.02148H16.0081C16.8337 5.02148 17.5825 5.35748 18.1249 5.89988C18.1969 5.97188 18.2593 6.04388 18.3265 6.12068"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.56323 16.416C6.18723 17.3808 7.27203 18.0192 8.51043 18.0192H15"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
